import {
    Paper,
    Table,
    Button,
    TextField,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    FormGroup,
    Typography,
    TableRow,
    TableHead,
    TableCell,
    LinearProgress,
  } from "@material-ui/core";
  import { Dialog } from "@mui/material";
  import Stack from '@mui/material/Stack';
  import GetRole from "./user";
  import { makeStyles } from "@material-ui/core/styles";
  import { rzprebookhotelbydest, rzbookhotel, rzcpbooking, rzhoteldetails, addrezData} from "../api/customerapi";
  import { useEffect } from "react";
  import useState from 'react-usestateref'
  import { XMLParser } from "fast-xml-parser";
  import { childagearray, getnationality } from "./date.js";
  
  const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
    },
    formgroup: {
      justifyContent: "center",
    },
  
    headertext: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(3),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(14),
      height: theme.spacing(5),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
      fontSize: 10,
      verticalAlign: "middle",
    },
    button2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(10),
      height: theme.spacing(3),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      fontSize: 10,
      verticalAlign: "middle",
    },
    textField: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      width: theme.spacing(20),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: "left",
    },
  }));
  
  const RezliveBook = ({responseData, roomdetails, hoteldetails, searchData, ssid}) => {
    const width = window.innerWidth - 100;
    const classes = useStyles();
    const [status, setstatus] = useState("Loading");
    const [bookstatus, setbookstatus] = useState("Loading");
    const [bookingflag, setbookingflag] = useState(false);
    const [responseData2, setresponseData2] = useState([{}]);
    const [responseData3, setresponseData3] = useState("");
    const [bookingresponse, setbookingresponse] = useState([{}]);
    var { cuser, role } = GetRole();
    const [Open5, setOpen5] = useState(false);
    const [Open6, setOpen6] = useState(false);
    const [hdData, sethdData] = useState([{}]);
    const [Open4, setOpen4] = useState(false);
    var [guestData, setguestData, guestDataRef] = useState([]);
    const [ssid2, setssid2] = useState([]);
    const [roomnum, setroomnum] = useState([]);
    const [dialog1, setdialog1] = useState(false);
    
    //console.log(hoteldetails)
    // console.log(roomdetails)

    useEffect(() => {
      prebookcheck()   
  }, [])

  useEffect(() => {
    //console.log("guestdata updated") 
    setbookingflag(true) 
}, [guestData])

    const prebookcheck = async() => {
      var nation=getnationality(searchData.nationality)

      var data={'XML': "<PreBookingRequest>\n <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n<PreBooking>\n<SearchSessionId>"+ssid+'</SearchSessionId>\n<ArrivalDate>'+responseData.ArrivalDate+'</ArrivalDate>\n <DepartureDate>'+responseData.DepartureDate+'</DepartureDate>\n <GuestNationality>'+nation+'</GuestNationality>\n <CountryCode>'+searchData.destcode+'</CountryCode>\n <City>'+searchData.citycode+'</City>\n <HotelId>'+hoteldetails.Id+'</HotelId>\n <Currency>INR</Currency>\n <RoomDetails>\n <RoomDetail>\n <Type>'+roomdetails.Type+'</Type>\n <BookingKey>'+roomdetails.BookingKey+'</BookingKey>\n <Adults>'+roomdetails.Adults+'</Adults>\n <Children>'+roomdetails.Children+'</Children>\n <ChildrenAges>'+roomdetails.ChildrenAges+'</ChildrenAges>\n <TotalRooms>'+roomdetails.TotalRooms+'</TotalRooms>\n <TotalRate>'+roomdetails.TotalRate+
      "</TotalRate>\n </RoomDetail>\n </RoomDetails>\n </PreBooking>\n </PreBookingRequest>"
    }
      
      console.log(data)

      const resdata=await rzprebookhotelbydest(data)
      setstatus("completed")
      console.log(resdata.data)
      /////////////////////////////////////////////////////////////////

       const parser = new XMLParser();
       let jObj = parser.parse(resdata.data);
        console.log(jObj.PreBookingResponse)
         setresponseData2(jObj.PreBookingResponse)

         if("PreBookingRequest" in jObj.PreBookingResponse && "PreBooking" in jObj.PreBookingResponse.PreBookingRequest) {
          var p1=resdata.data.split("<SearchSessionId>")
          var p2=p1[1].split("</SearchSessionId>")
          setssid2(p2[0])
         }
         
    }

    const getdetails=async()=>{
      setOpen4(true)
      var data = {
        'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelDetailsRequest>\n   <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n   <Hotels>\n      <HotelId>'+hoteldetails.Id+'</HotelId>\n  </Hotels>\n</HotelDetailsRequest>'
      };
      //console.log(data)
  
      const resdata=await rzhoteldetails(data)
      //console.log(resdata.data)
      const parser = new XMLParser();
      const jObj = parser.parse(resdata.data);
     //    //var xml = new XMLParser().parseFromString(xmlresponse);
        sethdData(jObj.HotelDetailsResponse)
        //console.log(jObj)
  }

    const rezbook = async(e) => {
      
      e.preventDefault()
      var nation=getnationality(searchData.nationality)
      var namearray=[]
      var guest=""
      for (let i=0;i<guestData.length;i++){
        var temp="<Guests>\n"
        //console.log(guestData)
        for (let j=0;j<guestData[i].adults.length;j++){
        var sal="<Salutation>"+guestData[i].adults[j].salutation+"</Salutation>\n"
        var fn="<FirstName>"+guestData[i].adults[j].firstname+"</FirstName>\n"
        var ln="<LastName>"+guestData[i].adults[j].lastname+"</LastName>\n"
        var name="<Guest>\n"+sal+fn+ln+"</Guest>\n"
        temp=temp+name
        const fullname=guestData[i].adults[j].firstname+guestData[i].adults[j].lastname
        namearray=[...namearray,fullname.toLowerCase().trim()]
        }
        //console.log(temp)
        //guest=guest+temp
        if(guestData[i].child){
          for (let k=0;k<guestData[i].child.length;k++){
            var fn="<FirstName>"+guestData[i].child[k].firstname+"</FirstName>\n"
            var ln="<LastName>"+guestData[i].child[k].lastname+"</LastName>\n"
            var ca="<Age>"+guestData[i].child[k].age+"</Age>\n"
            var name="<Guest>\n<Salutation>Child</Salutation>\n"+fn+ln+"<IsChild>1</IsChild>\n"+ca+"</Guest>\n"
            temp=temp+name
            const fullchildname=guestData[i].child[k].firstname+guestData[i].child[k].lastname
            namearray=[...namearray,fullchildname.toLowerCase().trim()]
          }
          
        }
        guest=guest+temp+"</Guests>\n"
      }

      let hasDuplicate = namearray.some((val, i) => namearray.indexOf(val) !== i);
      console.log(namearray)
      var ref=cuser+new Date()
      if(hasDuplicate){
        alert("Duplicate name present in guest name. Kindly enter unique names only")
      }else{

        var data={'XML': '<BookingRequest>\n <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n<Booking>\n<AgentRefNo>'+ref+'</AgentRefNo>\n <ArrivalDate>'+responseData.ArrivalDate+'</ArrivalDate>\n <DepartureDate>'+responseData.DepartureDate+'</DepartureDate>\n <GuestNationality>'+nation+'</GuestNationality>\n <CountryCode>'+searchData.destcode+'</CountryCode>\n <City>'+searchData.citycode+'</City>\n <HotelId>'+hoteldetails.Id+'</HotelId>\n<Name>'
    +hoteldetails.Name+'</Name>\n<Address />\n<Description />\n<Latitude />\n<Longitude />\n<ThumbImages>'+hoteldetails.ThumbImages+'</ThumbImages>\n<HotelImages />\n <Currency>INR</Currency>\n <RoomDetails>\n <RoomDetail>\n <Type>'+roomdetails.Type+'</Type>\n <BookingKey>'+responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.BookingKey+'</BookingKey>\n <Adults>'+roomdetails.Adults+'</Adults>\n <Children>'+roomdetails.Children+'</Children>\n <ChildrenAges>'+roomdetails.ChildrenAges+'</ChildrenAges>\n <TotalRooms>'+roomdetails.TotalRooms+'</TotalRooms>\n <TotalRate>'+roomdetails.TotalRate+
    '</TotalRate>\n<CancellationPolicy />\n'+guest+'</RoomDetail>\n </RoomDetails>\n</Booking>\n</BookingRequest>'
  }
      
      console.log(data)

      const resdata=await rzbookhotel(data)
      setbookstatus("completed")
      console.log(resdata.data)
      // /////////////////////////////////////////////////////////////////

       const parser = new XMLParser();
       let jObj = parser.parse(resdata.data);
        //console.log(jObj.BookingResponse)
        setbookingresponse(jObj.BookingResponse)
        setdialog1(true)
      if(jObj.BookingResponse){
        if("BookingDetails" in jObj.BookingResponse && "BookingRequest" in jObj.BookingResponse) {

          const bookingdata={
            bookingdate:new Date(),
            bookingcode:jObj.BookingResponse.BookingDetails.BookingCode,
            bookingid:jObj.BookingResponse.BookingDetails.BookingId,
            startdate:new Date(jObj.BookingResponse.BookingRequest.Booking.ArrivalDate),
            city:jObj.BookingResponse.BookingRequest.Booking.City,
            hotelname:jObj.BookingResponse.BookingRequest.Booking.Name,
            bookingstatus:jObj.BookingResponse.BookingDetails.BookingStatus,
            bookingprice:jObj.BookingResponse.BookingDetails.BookingPrice,
            bookedby:cuser,
          }
    
          const data3=await addrezData(bookingdata)
         }
      }

      }

    
       

      
    }

   

    const handleClose5 = () => {
      setOpen5(false);
    };

    const calccost=(str)=>{
      const temp=str.split("|")
      temp.map(s => s.trim());
      var numberArray = temp.map(Number)
      const sum = numberArray.reduce((partialSum, a) => partialSum + a, 0);
      return Math.round(sum)
  
    }

    const initiatebook=()=>{
      setbookingflag(true)
      
      var roomarr=[]
      for(let i=0;i<searchData.rooms.length;i++){
        var temparr=[]
        if(searchData.rooms[i].number_adults){
          temparr[0]=childagearray(searchData.rooms[i].number_adults)
        }
        if(searchData.rooms[i].number_child){
          //console.log("ABC"+i)
          temparr[1]=childagearray(searchData.rooms[i].number_child)
        }
        roomarr.push(temparr)
        //console.log(roomarr)
      }
      setroomnum(roomarr)
      getdetails()
      setOpen4(false)
    }

    const getcp=async()=>{
      setOpen5(true)
      var nation=getnationality(searchData.nationality)
      var data={'XML': '<CancellationPolicyRequest>\n <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n<ArrivalDate>'+responseData.ArrivalDate+'</ArrivalDate>\n <DepartureDate>'+responseData.DepartureDate+'</DepartureDate>\n <HotelId>'+hoteldetails.Id+'</HotelId>\n <CountryCode>'+searchData.destcode+'</CountryCode>\n <City>'+searchData.citycode+'</City>\n <GuestNationality>'+nation+'</GuestNationality>\n <Currency>INR</Currency>\n <RoomDetails>\n <RoomDetail>\n <Type>'+roomdetails.Type+'</Type>\n <BookingKey>'+roomdetails.BookingKey+'</BookingKey>\n <Adults>'+roomdetails.Adults+'</Adults>\n <Children>'+roomdetails.Children+'</Children>\n <ChildrenAges>'+roomdetails.ChildrenAges+'</ChildrenAges>\n </RoomDetail>\n </RoomDetails>\n </CancellationPolicyRequest>'}

      //console.log(data)

      const resdata=await rzcpbooking(data)
      console.log(resdata.data)

       const parser = new XMLParser();
       let jObj = parser.parse(resdata.data);
        console.log(jObj.CancellationPolicyResponse)
        setresponseData3(jObj.CancellationPolicyResponse)
    }

    const getcp2=async()=>{
      //setOpen5(true)
      var nation=getnationality(searchData.nationality)
      var data={'XML': '<CancellationPolicyRequest>\n <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n<ArrivalDate>'+responseData.ArrivalDate+'</ArrivalDate>\n <DepartureDate>'+responseData.DepartureDate+'</DepartureDate>\n <HotelId>'+hoteldetails.Id+'</HotelId>\n <CountryCode>'+searchData.destcode+'</CountryCode>\n <City>'+searchData.citycode+'</City>\n <GuestNationality>'+nation+'</GuestNationality>\n <Currency>INR</Currency>\n <RoomDetails>\n <RoomDetail>\n <Type>'+roomdetails.Type+'</Type>\n <BookingKey>'+roomdetails.BookingKey+'</BookingKey>\n <Adults>'+roomdetails.Adults+'</Adults>\n <Children>'+roomdetails.Children+'</Children>\n <ChildrenAges>'+roomdetails.ChildrenAges+'</ChildrenAges>\n </RoomDetail>\n </RoomDetails>\n </CancellationPolicyRequest>'}

      //console.log(data)

      const resdata=await rzcpbooking(data)
      //console.log(resdata.data)

       const parser = new XMLParser();
       let jObj = parser.parse(resdata.data);
        console.log(jObj.CancellationPolicyResponse)
        setresponseData3(jObj.CancellationPolicyResponse)
    }

    const adultfirstname=(roomnumber, adultnumber, value)=>{
      //guestData[roomnumber].adults[adultnumber]=value
      //console.log(value) 
      var temp=[...guestData]
      //console.log(temp)
      const temparr=guestData[roomnumber]?guestData[roomnumber].adults:[{}]
      var tempobj={}
      if(temparr[adultnumber]){
        temparr[adultnumber].firstname=value
      }else{
        temparr[adultnumber]={}
        temparr[adultnumber].firstname=value
      }
      if(guestData[roomnumber]){
        if('adults' in guestData[roomnumber] ){
          tempobj={...guestData[roomnumber], adults:temparr}
        }else{
          tempobj={...guestData[roomnumber], adults:temparr}
        }
      }else{
        tempobj={adults:temparr}
      }
      
    //   if(guestData[roomnumber]){// if(guestData.length==0){
    temp[roomnumber]=tempobj
    //   setguestData(temp)
    //   }else{
    //   //   temp=[...guestData.slice(0,roomnumber),tempobj,guestData.slice(roomnumber)]
    //   temp=[...guestData,tempobj]
    //   var temp2=temp.sort((a, b) => {
    //     return a.room - b.room;
    // });
    //   setguestData(temp2)
    
    //   }
      
     
       
      //console.log(temp)
      setguestData(temp)
      // return temp
      //setbookingflag(true) 
    }

    const adultlastname=(roomnumber, adultnumber, value)=>{
      //guestData[roomnumber].adults[adultnumber]=value
      //console.log(value) 
      var temp=[...guestData]
      //console.log(temp)
      const temparr=guestData[roomnumber]?guestData[roomnumber].adults:[{}]
      var tempobj={}
      if(temparr[adultnumber]){
        temparr[adultnumber].lastname=value
      }else{
        temparr[adultnumber]={}
        temparr[adultnumber].lastname=value
      }
      if(guestData[roomnumber]){
        if('adults' in guestData[roomnumber] ){
          tempobj={...guestData[roomnumber], adults:temparr}
        }else{
          tempobj={...guestData[roomnumber], adults:temparr}
        }
      }else{
        tempobj={adults:temparr}
      }
      
      temp[roomnumber]=tempobj
      //console.log(temp)
      setguestData(temp)
      // return temp
      //setbookingflag(true) 
    }

    const adultsalutation=(roomnumber, adultnumber, value)=>{
      //guestData[roomnumber].adults[adultnumber]=value
      //console.log(value) 
      var temp=[...guestData]
      //console.log(temp)
      const temparr=guestData[roomnumber]?guestData[roomnumber].adults:[{}]
      var tempobj={}
      if(temparr[adultnumber]){
        temparr[adultnumber].salutation=value
      }else{
        temparr[adultnumber]={}
        temparr[adultnumber].salutation=value
      }
      
      if(guestData[roomnumber]){
        if('adults' in guestData[roomnumber] ){
          tempobj={...guestData[roomnumber], adults:temparr}
        }else{
          tempobj={...guestData[roomnumber], adults:temparr}
        }
      }else{
        tempobj={adults:temparr}
      }
      
      temp[roomnumber]=tempobj
      //console.log(temp)
      setguestData(temp)
      // return temp
      //setbookingflag(true) 
    }

    const childfirstname=(roomnumber, childnumber, value)=>{
      //setbookingflag(false) 
      var temp=[...guestData]
      //console.log(temp)
      const temparr=guestData[roomnumber]?"child" in guestData[roomnumber]?guestData[roomnumber].child:[{}]:[{}]
      var tempobj={}
      if(temparr[childnumber]){
        temparr[childnumber].firstname=value
      }else{
        temparr[childnumber]={}
        temparr[childnumber].firstname=value
      }
      if(guestData[roomnumber]){
        if('child' in guestData[roomnumber] ){
          tempobj={...guestData[roomnumber], child:temparr}
        }else{
          tempobj={...guestData[roomnumber], child:temparr}
        }
      }else{
        tempobj={child:temparr}
      }
      
      temp[roomnumber]=tempobj
      //console.log(temp)
      setguestData(temp)
    }

    const childlastname=(roomnumber, childnumber, value)=>{
      var temp=[...guestData]
      //console.log(temp)
      const temparr=guestData[roomnumber]?"child" in guestData[roomnumber]?guestData[roomnumber].child:[{}]:[{}]
      var tempobj={}
      if(temparr[childnumber]){
        temparr[childnumber].lastname=value
      }else{
        temparr[childnumber]={}
        temparr[childnumber].lastname=value
      }
      if(guestData[roomnumber]){
        if('child' in guestData[roomnumber] ){
          tempobj={...guestData[roomnumber], child:temparr}
        }else{
          tempobj={...guestData[roomnumber], child:temparr}
        }
      }else{
        tempobj={child:temparr}
      }
      
      temp[roomnumber]=tempobj
      //console.log(temp)
      setguestData(temp)
    }

    const childage=(roomnumber, childnumber, value)=>{
      var temp=[...guestData]
      //console.log(temp)
      const temparr=guestData[roomnumber]?"child" in guestData[roomnumber]?guestData[roomnumber].child:[{}]:[{}]
      var tempobj={}
      if(temparr[childnumber]){
        temparr[childnumber].age=value
      }else{
        temparr[childnumber]={}
        temparr[childnumber].age=value
      }
      if(guestData[roomnumber]){
        if('child' in guestData[roomnumber] ){
          tempobj={...guestData[roomnumber], child:temparr}
        }else{
          tempobj={...guestData[roomnumber], child:temparr}
        }
      }else{
        tempobj={child:temparr}
      }
      
      temp[roomnumber]=tempobj
      //console.log(temp)
      setguestData(temp)
    }

    const handleClose4 = () => {
      sethdData([{}])
      setOpen4(false);
    };
    const handleClose1 = () => {
      setdialog1(false);
      window.location.href = "/hotelview";
      //window.open("/hotelview")
    };

    const handleClose6 = () => {
      
      setOpen6(false);
    };

    const prebookreconfirm = (e) => {
      e.preventDefault()
      let flag=1
      console.log(guestData)
      if(roomnum.length>0){
        // for(let k=0;k<roomnum.length;k++){

        // }
        for (let i=0;i<roomnum.length;i++){
          if(guestData[i] && "adults" in guestData[i]){
            for (let j=0;j<roomnum[i][0].length;j++){
              //console.log(flag, j)
              if(guestData[i].adults[j] && ("salutation" in guestData[i].adults[j] && guestData[i].adults[j].salutation!=="")&& ("firstname" in guestData[i].adults[j] && guestData[i].adults[j].firstname!=="")&& ("lastname" in guestData[i].adults[j] && guestData[i].adults[j].lastname!=="")){
                flag=0
              }else{
                flag=1
              }
            }
          }else{
            //console.log("ABC2")
            flag=1
          }
          
          if(roomnum[i].length>1 ){
            for (let j=0;j<roomnum[i][1].length;j++){
              if(guestData[i] && "child" in guestData[i] && guestData[i].child[j] && ("age" in guestData[i].child[j] && guestData[i].child[j].age!=="")&& ("firstname" in guestData[i].child[j] && guestData[i].child[j].firstname!=="")&& ("lastname" in guestData[i].child[j] && guestData[i].child[j].lastname!=="")){
                //console.log("ABC3")
                flag=0
                
              }else{
                flag=1
              }
            }
          }
          
        }
        if(flag){
          alert("Guest name or age cannot be blank")
        }else{
          setresponseData2([{}])
          setOpen6(true)
          prebookcheck() 
          getcp2()
        }
      }else{
        alert("Guest data not found")
      }
      
      
      
    } 
    
    //console.log(roomnum)

    return (
      <div>
      <Dialog fullWidth maxWidth="m" open={dialog1} onClose={handleClose1}>
      {bookstatus=="Loading"?(
        <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="inherit" />
      <LinearProgress color="primary" />
    </Stack>
      ):(
        <div>
        {bookingresponse && "BookingDetails" in bookingresponse?(
          <div>
          <Typography variant="h6">Booking Status: {bookingresponse.BookingDetails.BookingStatus}</Typography>
          <Typography variant="h6">Booking Price: {bookingresponse.BookingDetails.BookingPrice}</Typography>
          <Typography variant="h6">Booking Code: {bookingresponse.BookingDetails.BookingCode}</Typography>
          <Typography variant="h6">Booking Id: {bookingresponse.BookingDetails.BookingId}</Typography>
          <div align="center">
      <Button
              variant="outlined"
              color="secondary"
              className={classes.button3}
              href={"/hotelview"}
              
            >
              {" "}
              View Booked Hotels
            </Button>
      </div>
          </div>
        ):(
          <Typography variant="h6">Something went wrong. Booking did not process</Typography>
        )}
        </div>
      )}
      
        
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={Open6} onClose={handleClose6}>
      
      <Paper id="myDIV56" variant="outlined" className={classes.paper}>
        {responseData2 && "PreBookingRequest" in responseData2 && "PreBooking" in responseData2.PreBookingRequest?(<div>
          <FormGroup row className={classes.formgroup}>
                      <Typography variant="h6">
                        {" "}
                        Arrival Date: {responseData2.PreBookingRequest.PreBooking.ArrivalDate} || Departure
                        Date: {responseData2.PreBookingRequest.PreBooking.DepartureDate} || Currency:{" "}
                        {responseData2.PreBookingRequest.PreBooking.Currency} || Nationality:{" "}
                        {responseData2.PreBookingRequest.PreBooking.GuestNationality} || Balance: {responseData2.PreBookingDetails.AgentBalance}
                      </Typography>
                    </FormGroup>
                    <hr></hr>
                    <Table>
                    <TableRow>
                        <TableCell>
                          <b>Hotel:</b> {hoteldetails.Name}
                        </TableCell>
                        </TableRow>
                    <TableRow>
                        <TableCell>
                          <b>Type:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Type.includes("|")?(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Type.split("|").map(a=><p>{a}</p>)):(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Type)}
                        </TableCell>
                        </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Adults:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Adults}
                        </TableCell>
                        </TableRow>
                        <TableRow>
                        <TableCell>
                          <b>Children:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Children}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Age of Children:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.ChildrenAges}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Rooms:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TotalRooms}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Total:</b> {String(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TotalRate).includes("|")?calccost(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TotalRate):Math.round(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TotalRate)}
                        </TableCell>
                      </TableRow>
                      {Array.isArray(responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation)?(<div>
                        <TableRow>
                        <TableCell>
                          <b>Cancellation:</b> 
                         
                        </TableCell>
                      </TableRow>
                        {responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation.map(canc=>
                        <div>
                        
                      <TableRow>
                        <TableCell>
                          
                          From {canc.StartDate.slice(0,11)} to {canc.EndDate.slice(0,11)} - {canc.ChargeAmount} {canc.ChargeType}
                        </TableCell>
                      </TableRow>
                      
                        </div>
                        )}
                      </div>):(
                        <TableRow>
                        <TableCell>
                          <b>Cancellation:</b> 
                          From {responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation.StartDate.slice(0,11)} - {responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation.ChargeAmount} {responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation.ChargeType}
                        </TableCell>
                      </TableRow>
                      )}
                      
                      
                    </Table>
        </div>):(<Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>)}
        
                    <hr></hr>
                    {"PreBookingDetails" in responseData2?(<div>
                   
                      
                        {responseData2.PreBookingDetails.Difference?(
                          <div>
                          <Table>
                            <TableRow>
                              <TableCell>
                              <b>Old Price:</b> {responseData2.PreBookingDetails.BookingBeforePrice}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                              <b>New Price:</b> {responseData2.PreBookingDetails.BookingAfterPrice}
                              </TableCell>
                              <TableCell>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                              <b>Difference:</b> {responseData2.PreBookingDetails.Difference}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                              <Typography variant="h6">Booking will be made on new price</Typography>
                              </TableCell>
                            </TableRow>
                          </Table>
                          
                          
                          
                          
                          </div>
                        ):(
                          <div>
                          <Typography variant="h6">Price Matched. Proceed to book</Typography>
                          
                          </div>
                        )}
                      
                    
                    </div>):("")}
        </Paper>
        <Paper id="myDIV45" variant="outlined" className={classes.paper}>
        {responseData3?(
          <div>
            {"CancellationInformations" in responseData3 && "CancellationInformation" in responseData3.CancellationInformations?(
              <div>
              {Array.isArray(responseData3.CancellationInformations.CancellationInformation)?(
                <div>
                {responseData3.CancellationInformations.CancellationInformation.map(ci=>
              <h3 className={classes.headertext}>From {ci.StartDate} to {ci.EndDate} - {ci.ChargeAmount} {ci.ChargeType} {ci.Currency}</h3>
              )}
              </div>
              ):(<div>
                <h3 className={classes.headertext}>From {responseData3.CancellationInformations.CancellationInformation.StartDate} to {responseData3.CancellationInformations.CancellationInformation.EndDate} -  {responseData3.CancellationInformations.CancellationInformation.ChargeAmount} {responseData3.CancellationInformations.CancellationInformation.ChargeType} {responseData3.CancellationInformations.CancellationInformation.Currency}</h3>
              </div>)}
              
              </div>
            ):("Cancellation Policy not found")}
          </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
        </Paper>
        <div align="center">
        {role=="Admin" || role=="TL"?(<Button
                            variant="contained"
                            type="submit"
                            color="primary"
                            onClick={e=>rezbook(e)}
                            className={classes.button2}
                            >
                              Book
                          </Button>):("")}
        
                          <Button
                            variant="contained"
                            
                            color="secondary"
                            onClick={()=>handleClose6()}
                            className={classes.button2}
                            >
                              Cancel
                          </Button>
        </div>
        
      </Dialog>
        <div>
        {status=="Loading"?(
        <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="inherit" />
      <LinearProgress color="primary" />
    </Stack>
      ):(
        <div>
        <Paper id="myDIV" variant="outlined" className={classes.paper}>
        {responseData2 && "PreBookingRequest" in responseData2 && "PreBooking" in responseData2.PreBookingRequest?(<div>
          <FormGroup row className={classes.formgroup}>
                      <Typography variant="h6">
                        {" "}
                        Arrival Date: {responseData2.PreBookingRequest.PreBooking.ArrivalDate} || Departure
                        Date: {responseData2.PreBookingRequest.PreBooking.DepartureDate} || Currency:{" "}
                        {responseData2.PreBookingRequest.PreBooking.Currency} || Nationality:{" "}
                        {responseData2.PreBookingRequest.PreBooking.GuestNationality} || Balance: {responseData2.PreBookingDetails.AgentBalance}
                      </Typography>
                    </FormGroup>
                    <hr></hr>
                    <Table>
                    <TableRow>
                        <TableCell>
                          <b>Hotel:</b> {hoteldetails.Name}
                        </TableCell>
                        </TableRow>
                    <TableRow>
                        <TableCell>
                          <b>Type:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Type.includes("|")?(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Type.split("|").map(a=><p>{a}</p>)):(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Type)}
                        </TableCell>
                        </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Adults:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Adults}
                        </TableCell>
                        </TableRow>
                        <TableRow>
                        <TableCell>
                          <b>Children:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.Children}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Age of Children:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.ChildrenAges}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Rooms:</b> {responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TotalRooms}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Total:</b> {String(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TotalRate).includes("|")?calccost(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TotalRate):Math.round(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TotalRate)}
                        </TableCell>
                      </TableRow>
                      {Array.isArray(responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation)?(<div>
                        <TableRow>
                        <TableCell>
                          <b>Cancellation:</b> 
                         
                        </TableCell>
                      </TableRow>
                        {responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation.map(canc=>
                        <div>
                        
                      <TableRow>
                        <TableCell>
                          
                          From {canc.StartDate.slice(0,11)} to {canc.EndDate.slice(0,11)} - {canc.ChargeAmount} {canc.ChargeType}
                        </TableCell>
                      </TableRow>
                      
                        </div>
                        )}
                      </div>):(
                        <TableRow>
                        <TableCell>
                          <b>Cancellation:</b> 
                          From {responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation.StartDate.slice(0,11)} - {responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation.ChargeAmount} {responseData2.PreBookingRequest.PreBooking.CancellationInformations.CancellationInformation.ChargeType}
                        </TableCell>
                      </TableRow>
                      )}
                      {/* <TableRow>
                        <TableCell>
                          
                          TnC: {String(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TermsAndConditions).includes("|")?(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TermsAndConditions.split("|").map(a=><p>{a}</p>)):(responseData2.PreBookingRequest.PreBooking.RoomDetails.RoomDetail.TermsAndConditions)}
                        </TableCell>
                      </TableRow> */}
                      
                    </Table>
        </div>):("Something went wrong")}
        
                    <hr></hr>
                    {"PreBookingDetails" in responseData2?(<div>
                   
                      
                        {responseData2.PreBookingDetails.Difference?(
                          <div>
                          <Table>
                            <TableRow>
                              <TableCell>
                              <b>Old Price:</b> {responseData2.PreBookingDetails.BookingBeforePrice}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                              <b>New Price:</b> {responseData2.PreBookingDetails.BookingAfterPrice}
                              </TableCell>
                              <TableCell>
                              <Button
                            variant="contained"
                            color="primary"
                            onClick={e=>initiatebook()}
                            className={classes.button2}
                            >
                              Accept
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={e=>getcp()}
                            className={classes.button2}
                            >
                              Cancellation
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={e=>getdetails()}
                            className={classes.button2}
                            >
                              Details
                          </Button>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                              <b>Difference:</b> {responseData2.PreBookingDetails.Difference}
                              </TableCell>
                            </TableRow>
                          </Table>
                          
                          
                          
                          
                          </div>
                        ):(
                          <div>
                          <Typography variant="h6">Price Matched. Proceed to book</Typography>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={e=>initiatebook()}
                            className={classes.button2}
                            >
                              Book
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={e=>getcp()}
                            className={classes.button2}
                            >
                              Cancellation
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={e=>getdetails()}
                            className={classes.button2}
                            >
                              Details
                          </Button>
                          
                          </div>
                        )}
                      
                    
                    </div>):("")}
        </Paper>
        {bookingflag?(
          <Paper id="myDIV2" variant="outlined" className={classes.paper}>
          <form>
              {roomnum.map(arr=>
              <div>
              
              <h4>Room {roomnum.indexOf(arr)+1}</h4>
                {arr[0].map(a=>
                <div>
                
                <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="salutation">Salutation</InputLabel>
                    <Select
                      
                      required
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="salutation"
                      label={"Adult "+ (a)}
                      variant="outlined"
                      value={guestData.length>0?
                        guestData[roomnum.indexOf(arr)]?
                      guestData[roomnum.indexOf(arr)].adults[a-1]?
                      guestData[roomnum.indexOf(arr)].adults[a-1].salutation
                      :"":"":""}
                      onChange={(e) =>
                        adultsalutation(roomnum.indexOf(arr),a-1, e.target.value)
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                      
                      <MenuItem value={"Mr."}>Mr.</MenuItem>
                      <MenuItem value={"Mrs."}>Mrs.</MenuItem>
                      <MenuItem value={"Ms."}>Ms.</MenuItem>
                     
                    </Select>
                  </FormControl>
                  <TextField
                    variant="outlined"
                    label={"Adult "+ (a)+" First Name"}
                    value={guestData.length>0?
                      guestDataRef.current[roomnum.indexOf(arr)]?
                    guestDataRef.current[roomnum.indexOf(arr)].adults[a-1]?
                    guestDataRef.current[roomnum.indexOf(arr)].adults[a-1].firstname
                    :"":"":""}
                    //value={temp>0?temp[roomnum.indexOf(arr)]?.adults[a-1]:""}
                    className={classes.textField}
                    required
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      adultfirstname(roomnum.indexOf(arr),a-1, e.target.value)
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    label={"Adult "+ (a)+" Last Name"}
                    value={guestData.length>0?
                      guestDataRef.current[roomnum.indexOf(arr)]?
                    guestDataRef.current[roomnum.indexOf(arr)].adults[a-1]?
                    guestDataRef.current[roomnum.indexOf(arr)].adults[a-1].lastname
                    :"":"":""}
                    //value={temp>0?temp[roomnum.indexOf(arr)]?.adults[a-1]:""}
                    className={classes.textField}
                    required
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      adultlastname(roomnum.indexOf(arr),a-1, e.target.value)
                    }
                   
                  />
                  <br></br>
                  </div>
                )}
                {arr[1]?(
                  <div>
                  {arr[1].map(c=>
                  <div>
                  <TextField
                    variant="outlined"
                    required
                    label={"Child "+ (c)+" First Name"}
                    value={guestData.length>0?
                      guestDataRef.current[roomnum.indexOf(arr)]?
                    "child" in guestDataRef.current[roomnum.indexOf(arr)]?
                    guestDataRef.current[roomnum.indexOf(arr)]?.child[c-1]?
                    guestDataRef.current[roomnum.indexOf(arr)].child[c-1].firstname
                    :"":"":"":""}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      childfirstname(roomnum.indexOf(arr),c-1, e.target.value)
                    }
                  />
                  <TextField
                    variant="outlined"
                    label={"Child "+(c)+" Last Name"}
                    value={guestData.length>0?
                      guestDataRef.current[roomnum.indexOf(arr)]?
                    "child" in guestDataRef.current[roomnum.indexOf(arr)]?
                    guestDataRef.current[roomnum.indexOf(arr)]?.child[c-1]?
                    guestDataRef.current[roomnum.indexOf(arr)].child[c-1].lastname
                    :"":"":"":""}
                    className={classes.textField}
                    required
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      childlastname(roomnum.indexOf(arr),c-1, e.target.value)
                    }
                   
                  />
                  <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="age">Age</InputLabel>
                    <Select
                      displayEmpty
                      required
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="Age"
                      label={"Child "+(c)+" Age"}
                      variant="outlined"
                      value={guestData.length>0?
                        guestDataRef.current[roomnum.indexOf(arr)]?
                    "child" in guestDataRef.current[roomnum.indexOf(arr)]?
                    guestDataRef.current[roomnum.indexOf(arr)]?.child[c-1]?
                    guestDataRef.current[roomnum.indexOf(arr)].child[c-1].age
                    :"":"":"":""}
                      onChange={(e) =>
                        childage(roomnum.indexOf(arr),c-1, e.target.value)
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                      
                     
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={6}>6</MenuItem>
                      <MenuItem value={7}>7</MenuItem>
                      <MenuItem value={8}>8</MenuItem>
                      <MenuItem value={9}>9</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={11}>11</MenuItem>
                      <MenuItem value={12}>12</MenuItem>
                    </Select>
                  </FormControl>
                  <br></br>
                  </div>
                )}
                  </div>
                ):("")}
              </div>
                    
                  ) }
                  {guestData.length>0?(
                    <Button
                            variant="contained"
                            type="submit"
                            color="primary"
                            onClick={e=>prebookreconfirm(e)}
                            className={classes.button2}
                            >
                              Re-Confirm
                          </Button>
                  ):("")}
                  </form>  
          </Paper>
        ):("")}
        </div>
      )}
      </div>
      <Dialog fullWidth maxWidth="m" open={Open5} onClose={handleClose5}>
        {responseData3?(
          <div>
            {"CancellationInformations" in responseData3 && "CancellationInformation" in responseData3.CancellationInformations?(
              <div>
              {Array.isArray(responseData3.CancellationInformations.CancellationInformation)?(
                <div>
                {responseData3.CancellationInformations.CancellationInformation.map(ci=>
              <h3 className={classes.headertext}>From {ci.StartDate} to {ci.EndDate} - {ci.ChargeAmount} {ci.ChargeType} {ci.Currency}</h3>
              )}
              </div>
              ):(<div>
                <h3 className={classes.headertext}>From {responseData3.CancellationInformations.CancellationInformation.StartDate} to {responseData3.CancellationInformations.CancellationInformation.EndDate} -  {responseData3.CancellationInformations.CancellationInformation.ChargeAmount} {responseData3.CancellationInformations.CancellationInformation.ChargeType} {responseData3.CancellationInformations.CancellationInformation.Currency}</h3>
              </div>)}
              
              </div>
            ):("Cancellation Policy not found")}
          </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={Open4} onClose={handleClose4}>
        {hdData?(
          <div>
            {hdData.Hotels?(
              <div>
                <h2 className={classes.headertext}>Name: {hdData.Hotels.HotelName}</h2>
                <h2 className={classes.headertext}>Location: {hdData.Hotels.City}, {hdData.Hotels.Country} </h2>
                <h2 className={classes.headertext}>Address: {hdData.Hotels.HotelAddress}</h2>
                <h2 className={classes.headertext}>Contact: {hdData.Hotels.Phone} </h2>
                <h2 className={classes.headertext}>Description:</h2>
                <h4 className={classes.headertext}>{hdData.Hotels.Description}</h4>
                <h2 className={classes.headertext}>Hotel Amenities:</h2>
                <h4 className={classes.headertext}>{hdData.Hotels.HotelAmenities}</h4>
                <h2 className={classes.headertext}>Room Amenities:</h2>
                <h4 className={classes.headertext}>{hdData.Hotels.RoomAmenities}</h4>
              </div>
            ):("Hotel Details not found")}
          </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>
      </div>
    );
  };
  
  export default RezliveBook;
  